export function getPublicUrl(input) {
  if (!input) return input
  try {
    const urlObj = new URL(input)
    const hostname = urlObj.hostname
    if (hostname.includes('s3.amazonaws.com') || hostname.includes('.s3.')) {
      // parse bucket and key
      const pathSegments = urlObj.pathname.split('/').filter(Boolean)
      let bucket = ''
      let key = ''
      if (hostname.includes('s3.amazonaws.com')) {
        if (pathSegments.length >= 2) {
          bucket = pathSegments[0]
          key = pathSegments.slice(1).join('/')
        }
      } else {
        bucket = hostname.split('.')[0]
        key = pathSegments.join('/')
      }
      return buildPublicUrl(bucket, key)
    }
    // other absolute URLs return as-is
    return input
  } catch (e) {
    // input not a URL, interpret as path or key
    return buildPublicUrlFromPath(input)
  }
}

function buildPublicUrlFromPath(path) {
  const base = process.env.REACT_APP_MINIO_PUBLIC_BASE_URL || process.env.REACT_APP_STORAGE_PUBLIC_BASE_URL || ''
  const bucket = process.env.REACT_APP_PUBLIC_STORAGE_BUCKET || process.env.REACT_APP_S3_BUCKET || 'rushi2023'
  if (!base) return `https://${bucket}.s3.amazonaws.com/${path}`
  return `${base.replace(/\/$/, '')}/${bucket}/${path}`
}

function buildPublicUrl(bucket, key) {
  const base = process.env.REACT_APP_MINIO_PUBLIC_BASE_URL || process.env.REACT_APP_STORAGE_PUBLIC_BASE_URL || ''
  if (!base) return `https://${bucket}.s3.amazonaws.com/${key}`
  return `${base.replace(/\/$/, '')}/${bucket}/${key}`
}

export default getPublicUrl
